export default {
  getTopicFeedbackQuestion: '/topicFeedbackQuestion/getTopicFeedbackQuestion',
  updateTopicFeedbackQuestion:
    '/topicFeedbackQuestion/updateTopicFeedbackQuestion',
  createTopicFeedbackQuestion:
    '/topicFeedbackQuestion/createTopicFeedbackQuestion'
}
